import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Select,
  MenuItem,
  TableCell,
  IconButton,
  Tooltip
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import { ContatoExterno, TipoContato } from '../../services/api/contatos';
import { ContatoTable } from './contatoEmergencialTable';
import { ContatoExternoRegister } from '../modals/contatoAddmodal';
import { Paginated, RequestError, useApi } from '../../services';
import { ErrorOnDialog } from '../modals';
import { ConfirmModal } from '../modals';

interface Props {
  idBarragem: number;
  isAdmin: boolean;
  changeType?: boolean;
}

export const ContatosExternosPage: React.FC<Props> = ({ idBarragem, isAdmin, changeType }) => {
  const api = useApi();

  const [openDialog, setOpenDialog] = useState(false);
  const [state, setState] = useState(false);
  const [tipo, setTipo] = useState<TipoContato | "all">("all");
  const [error, setError] = useState<RequestError>();
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedContato, setSelectedContato] = useState<ContatoExterno | null>(null);
  const [paginate, setPaginate] = useState<Paginated<ContatoExterno>>({
    items: [],
    page: 1,
    perPage: 50,
    totalItems: 1,
    totalPages: 1,
  });

  const fetchData = () => {
    if (tipo !== "all") {
      api.contato.getContatosExternos(idBarragem, tipo, paginate.page, paginate.perPage).then(value => {
        if ("error" in value) {
          setError(value);
          return;
        }
        setPaginate(value);
      });
      return;
    }

    api.contato.getContatosExternos(idBarragem, 'all', paginate.page, paginate.perPage).then(value => {
      if ("error" in value) {
        setError(value);
        return;
      }
      setPaginate(value);
    });
  };

  useEffect(() => {
    fetchData();
  }, [idBarragem, tipo, state, paginate.page, paginate.perPage]);

  const handleDelete = (contato: ContatoExterno) => {
    setSelectedContato(contato);
    setShowConfirm(true);
  };

  const confirmDelete = async () => {
    if (!selectedContato) return;

    const result = await api.contato.deleteContatoExterno(selectedContato.id);
    if ("error" in result) {
      setError(result);
      return;
    }

    setState(!state);
    setShowConfirm(false);
    setSelectedContato(null);
  };

  return (
    <>
      <ErrorOnDialog
        open={Boolean(error)}
        error={error?.error ?? ""}
        message={error?.message ?? ""}
        onClose={() => setError(undefined)}
      />

      <ContatoExternoRegister
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        idBarragem={idBarragem}
        onSuccess={() => {
          fetchData();
          setOpenDialog(false);
        }}
      />


      <ConfirmModal
        open={showConfirm}
        title="Confirmar Exclusão"
        message={`Tem certeza que deseja remover o contato "${selectedContato?.elemento_notificacao}"?`}
        onConfirm={confirmDelete}
        onCancel={() => {
          setShowConfirm(false);
          setSelectedContato(null);
        }}
      />

      <Box p={3} sx={{ width: "100%", height: "100%" }}>

        <div style={{
          display: "flex",
          flexDirection: "row",
        }}>
          <Typography variant="h5" mb={2}>{`Contatos Externos${tipo === "municipal" ? ' Municipais' : tipo === "estadual" ? " Estaduais" : tipo === "federal" ? " Federais" : ""}`}</Typography>
          <div style={{ flex: 1 }} />
          {isAdmin && (
            <Tooltip title="Cadastrar Contato">
              <IconButton onClick={() => setOpenDialog(true)} >
                <Edit />
              </IconButton>
            </Tooltip>
          )}
        </div>

        {changeType && <Select
          value={tipo}
          onChange={(e) => {
            setTipo(e.target.value as TipoContato);
            setState(!state);
          }}
          sx={{ mb: 2 }}
          size="small"
        >
          <MenuItem value="all">Todos</MenuItem>
          <MenuItem value="municipal">Municipal</MenuItem>
          <MenuItem value="estadual">Estadual</MenuItem>
          <MenuItem value="federal">Federal</MenuItem>
        </Select>}

        <Box sx={{ flex: 1, width: "100%", height: `calc(100%${changeType ? ' - 56px' : ""})` }}>
          <ContatoTable<ContatoExterno>
            data={paginate.items}
            page={paginate.page - 1}
            perPage={paginate.perPage}
            totalItems={paginate.totalItems}
            onPageChange={(page) => setPaginate({ ...paginate, page: page + 1 })}
            onPerPageChange={(perPage) => setPaginate({ ...paginate, perPage: perPage })}
            showAcoes={isAdmin}
            isExterno
            renderCabecalho={() => (
              <>
                <TableCell>Tipo</TableCell>
                <TableCell>Elemento de Notificação</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Sítio</TableCell>
              </>
            )}
            renderColunas={(c) => (
              <>
                <TableCell>{c.tipo.toLocaleUpperCase()}</TableCell>
                <TableCell>{c.elemento_notificacao}</TableCell>
                <TableCell>{c.email}</TableCell>
                <TableCell>{c.sitio}</TableCell>
              </>
            )}
            onDelete={handleDelete}
          />
        </Box>
      </Box>
    </>
  );
};